<template>
  <div
    class="absolute inset-0 z-50 gap-3 items-center justify-center bg-secondary-50 flex"
  >
    <div
      v-for="(delay, index) in delays"
      :key="index"
      class="w-4 h-4 relative bg-secondary-800 outline-[3px] rounded-full animate-loaderAnim"
      :style="{ animationDelay: delay }"
    ></div>
  </div>
</template>

<script lang="ts" setup>
const delays = ['0.1s', '0.3s', '0.5s', '0.7s', '0.9s']
</script>
